/* eslint-disable spaced-comment */

import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton';
import FileDownload from '@material-ui/icons/FileDownload';

import CustomerDocUpload from '../components/CustomerDocUpload';
import DataEntryLink from './DataEntryLink';

const taskTypes = {
  'doc-upload': 'Doc Upload',
  'doc-verify': 'Doc Verify',
  query: 'Query',
  todo: 'ToDo',
  'data-entry': 'Data Entry',
  'multi-doc': 'Multiple Doc Upload',
};

const { Column } = Table;

const Tasks = (props) => (
  <Table dataSource={props.tasks.filter((task) => (!task.completed))} rowKey="id">
    <Column
      width={15}
      key="priority"
      onCell={(record) => {
        let color = '#0000FF';
        if (record.priority === 1) color = '#FF0000';
        if (record.priority === 2) color = '#FFFF00';
        return {
          style: {
            backgroundColor: color,
            padding: 0,
          },
        };
      }}
      onHeaderCell={() => ({ style: { padding: 0 } })}
      filters={[
        {
          text: 'Low Priority',
          value: 3,
        },
        {
          text: 'Medium Priority',
          value: 2,
        },
        {
          text: 'High Priority',
          value: 1,
        },
      ]}
      onFilter={(value, record) => (record.priority === value)}
    />
    <Column
      width={130}
      title="Type"
      dataIndex="type"
      key="type"
      render={(text) => (taskTypes[text])}
      filters={[
        {
          text: 'Document Upload',
          value: 'doc-upload',
        },
        {
          text: 'Document Verification',
          value: 'doc-verify',
        },
        {
          text: 'Query',
          value: 'query',
        },
        {
          text: 'ToDo',
          value: 'todo',
        },
        {
          text: 'Data Entry',
          value: 'data-entry',
        },
        {
          text: 'Multiple Documents Upload',
          value: 'multi-doc',
        },
      ]}
      onFilter={(value, record) => (record.type === value)}
    />
    <Column
      title="Due Date"
      dataIndex="due_date"
      key="due_date"
      sorter={(a, b) => {
        let dateA = null;
        let dateB = null;
        if (a.dueDate) dateA = new Date(a.dueDate);
        else dateA = new Date(0);
        if (b.dueDate) dateB = new Date(b.dueDate);
        else dateB = new Date(0);
        return (dateA - dateB);
      }}
    />
    <Column
      title="Title"
      dataIndex="title"
      key="title"
    />
    <Column
      title="Description"
      dataIndex="description"
      key="description"
      // width="30%"
    />
    <Column
      title="Actions"
      key="actions"
      render={(text, record) => (
        <div>
          {(record.type === 'doc-upload' || record.type === 'data-entry') ? null : <Checkbox />}
          {
            (record.type === 'doc-upload') ?
              <CustomerDocUpload task_id={record.id} customerDoc={record.doc} customer_id={props.customer_id} />
              : null
          }
          {
            (record.type === 'data-entry' || record.type === 'multi-doc') ?
              <DataEntryLink dataEntryKey={record.data_entry_key} />
              :
              null
          }
          {
            (record.type === 'doc-verify') ?
              <IconButton aria-label="Download document" color="primary" href={record.doc.download_url}>
                <FileDownload />
              </IconButton>
              : null
          }
          {/*<IconButton aria-label="Edit" color="primary" onClick={this.toggleDrawer('edit', true)}>*/}
          {/*<ModeEdit />*/}
          {/*</IconButton>*/}
          {/*<IconButton aria-label="Comments" color="primary">*/}
          {/*<Badge badgeContent={10} color="secondary">*/}
          {/*<Comment />*/}
          {/*</Badge>*/}
          {/*</IconButton>*/}
        </div>
      )}
    />
  </Table>
);

Tasks.propTypes = {
  tasks: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    type: PropTypes.string,
  })),
  customer_id: PropTypes.string.isRequired,
};

Tasks.defaultProps = {
  tasks: [],
};

export default Tasks;



// WEBPACK FOOTER //
// ./src/components/Tasks.jsx